<template>
  <div>
    <el-card class="mat12">
      <el-row>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':isCheck}">
          <span v-if="isCheck">*</span>
          <h4 class="flex_shrink">姓名：</h4>
          <span
            :class="{'ellipsis':$store.getters.tagView}"
            :title="staffDetail.staffBasis.name"
          >{{ staffDetail.staffBasis.name }}</span>
          <i class="el-icon-view view_history" v-popover:popover1 v-if="isCheck"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover1"
            placement="right"
            title="姓名："
            width="200"
            trigger="click"
            :content="staffDetail.staffBasis.name"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':isCheck}">
          <span v-if="isCheck">*</span>
          <h4 class="flex_shrink">人员编号：</h4>
          <span
            :class="{'ellipsis':$store.getters.tagView}"
            :title="staffDetail.staffBasis.code"
          >{{staffDetail.staffBasis.code}}</span>
          <i class="el-icon-view view_history" v-popover:popover2 v-if="isCheck"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover2"
            placement="right"
            title="人员编号："
            width="200"
            trigger="click"
            :content="staffDetail.staffBasis.code + ''"
          ></el-popover>
        </el-col>
          <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':isCheck}">
          <span v-if="isCheck">*</span>
          <h4 class="flex_shrink">合同编号：</h4>
          <span
            :class="{'ellipsis':$store.getters.tagView}"
            :title="staffDetail.staffBasis.contractCode"
          >{{staffDetail.staffBasis.contractCode}}</span>
          <i class="el-icon-view view_history" v-popover:popover19 v-if="isCheck"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover19"
            placement="right"
            title="合同编号："
            width="200"
            trigger="click"
            :content="staffDetail.staffBasis.contractCode + ''"
          ></el-popover>
        </el-col>
         <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':isCheck}">
          <span v-if="isCheck">*</span>
          <h4 class="flex_shrink">入职时间：</h4>
          <span
            :class="{'ellipsis':$store.getters.tagView}"
            :title="staffDetail.staffBasis.joinDate"
          >{{staffDetail.staffBasis.joinDate}}</span>
          <i class="el-icon-view view_history" v-popover:popover20 v-if="isCheck"></i>
          <el-popover
            ref="popover20"
            placement="right"
            title="入职时间："
            width="200"
            trigger="click"
            :content="staffDetail.staffBasis.joinDate + ''"
          ></el-popover>
        </el-col>

        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':isCheck}">
          <span v-if="isCheck">*</span>
          <h4 class="flex_shrink">性别：</h4>
          <span
            :class="{'ellipsis':$store.getters.tagView}"
            :title="staffDetail.staffBasis.sex"
          >{{ staffDetail.staffBasis.sex }}</span>
          <i class="el-icon-view view_history" v-popover:popover3 v-if="isCheck"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover3"
            placement="right"
            title="性别："
            width="200"
            trigger="click"
            :content="staffDetail.staffBasis.name"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':isCheck}">
          <span v-if="isCheck">*</span>
          <h4 class="flex_shrink">出生日期：</h4>
          <span
            :class="{'ellipsis':$store.getters.tagView}"
            :title="staffDetail.staffBasis.birthday"
          >{{ staffDetail.staffBasis.birthday }}</span>
          <i class="el-icon-view view_history" v-popover:popover4 v-if="isCheck"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover4"
            placement="right"
            title="出生日期："
            width="200"
            trigger="click"
            :content="staffDetail.staffBasis.birthday"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':isCheck}">
          <span v-if="isCheck">*</span>
          <h4 class="flex_shrink">身份证号：</h4>
          <span
            class="ellipsis"
            :title="staffDetail.staffBasis.idNum"
          >{{ staffDetail.staffBasis.idNum }}</span>
          <i class="el-icon-view view_history" v-popover:popover5 v-if="isCheck"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover5"
            placement="right"
            title="身份证号："
            width="200"
            trigger="click"
            :content="staffDetail.staffBasis.idNum"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':isCheck}">
          <span v-if="isCheck">*</span>
          <h4 class="flex_shrink">手机号：</h4>
          <span
            :class="{'ellipsis':$store.getters.tagView}"
            :title="staffDetail.staffBasis.phone"
          >{{ staffDetail.staffBasis.phone }}</span>
          <i class="el-icon-view view_history" v-popover:popover6 v-if="isCheck"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover6"
            placement="right"
            title="手机号："
            width="200"
            trigger="click"
            :content="staffDetail.staffBasis.phone"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10" :class="{'contrast':isCheck}">
          <span v-if="isCheck">*</span>
          <h4>身高：</h4>
          {{ staffDetail.staffBasis.height }} cm
          <i
            class="el-icon-view view_history"
            v-popover:popover7
            v-if="isCheck"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover7"
            placement="right"
            title="身高："
            width="200"
            trigger="click"
            :content="staffDetail.staffBasis.height"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10" :class="{'contrast':isCheck}">
          <span v-if="isCheck">*</span>
          <h4>学历：</h4>
          {{ staffDetail.staffBasis.education }}
          <i
            class="el-icon-view view_history"
            v-popover:popover8
            v-if="isCheck"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover8"
            placement="right"
            title="学历："
            width="200"
            trigger="click"
            :content="staffDetail.staffBasis.education"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10" :class="{'contrast':isCheck}">
          <span v-if="isCheck">*</span>
          <h4>是否服役：</h4>
          {{ staffDetail.staffBasis.militaryService }}
          <i
            class="el-icon-view view_history"
            v-popover:popover9
            v-if="isCheck"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover9"
            placement="right"
            title="是否服役："
            width="200"
            trigger="click"
            :content="staffDetail.staffBasis.militaryService"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10" :class="{'contrast':isCheck}">
          <span v-if="isCheck">*</span>
          <h4>政治面貌：</h4>
          {{ staffDetail.staffBasis.politicalStatus }}
          <i
            class="el-icon-view view_history"
            v-popover:popover10
            v-if="isCheck"
          ></i>
          <!-- 显示 -->
          <el-popover
            ref="popover10"
            placement="right"
            title="政治面貌："
            width="200"
            trigger="click"
            :content="staffDetail.staffBasis.politicalStatus"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':isCheck}">
          <span v-if="isCheck">*</span>
          <h4 class="flex_shrink">户口所在地：</h4>
          <span
            class="ellipsis"
            :class="{'ellipsis':$store.getters.tagView}"
            :title="staffDetail.staffBasis.nativePlace"
          >{{ staffDetail.staffBasis.nativePlace }}</span>
          <i class="el-icon-view view_history" v-popover:popover11 v-if="isCheck"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover11"
            placement="right"
            title="户口所在地："
            width="200"
            trigger="click"
            :content="staffDetail.staffBasis.nativePlace"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':isCheck}">
          <span v-if="isCheck">*</span>
          <h4 class="flex_shrink">籍贯：</h4>
          <span
            class="ellipsis"
            :class="{'ellipsis':$store.getters.tagView}"
            :title="staffDetail.staffBasis.registered"
          >{{ staffDetail.staffBasis.registered }}</span>
          <i class="el-icon-view view_history" v-popover:popover12 v-if="isCheck"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover12"
            placement="right"
            title="籍贯："
            width="200"
            trigger="click"
            :content="staffDetail.staffBasis.registered"
          ></el-popover>
        </el-col>

        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':isCheck}">
          <span v-if="isCheck">*</span>
          <h4 class="flex_shrink">居住地址：</h4>
          <span
           class="ellipsis"
             :class="{'ellipsis':$store.getters.tagView}"
            :title="staffDetail.staffBasis.place"
          >{{ staffDetail.staffBasis.place }}</span>
          <i class="el-icon-view view_history" v-popover:popover13 v-if="isCheck"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover13"
            placement="right"
            title="居住地址："
            width="200"
            trigger="click"
            :content="staffDetail.staffBasis.place"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':isCheck}">
          <span v-if="isCheck">*</span>
          <h4 class="flex_shrink">紧急联系人：</h4>
          <span
            :class="{'ellipsis':$store.getters.tagView}"
            :title="staffDetail.staffBasis.emergencyContact"
          >{{ staffDetail.staffBasis.emergencyContact }}</span>
          <i class="el-icon-view view_history" v-popover:popover14 v-if="isCheck"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover14"
            placement="right"
            title="紧急联系人："
            width="200"
            trigger="click"
            :content="staffDetail.staffBasis.emergencyContact"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':isCheck}">
          <span v-if="isCheck">*</span>
          <h4 class="flex_shrink">紧急联系人电话：</h4>
          <span
            :class="{'ellipsis':$store.getters.tagView}"
            :title="staffDetail.staffBasis.emergencyPhone"
          >{{ staffDetail.staffBasis.emergencyPhone }}</span>
          <i class="el-icon-view view_history" v-popover:popover15 v-if="isCheck"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover15"
            placement="right"
            title="紧急联系人电话："
            width="200"
            trigger="click"
            :content="staffDetail.staffBasis.emergencyPhone"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':isCheck}">
          <span v-if="isCheck">*</span>
          <h4 class="flex_shrink">资格证类型：</h4>
          <span
            :class="{'ellipsis':$store.getters.tagView}"
            :title="staffDetail.staffBasis.securityStaffType"
          >{{ staffDetail.staffBasis.securityStaffType?staffDetail.staffBasis.securityStaffType:"暂无" }}</span>
          <i class="el-icon-view view_history" v-popover:popover16 v-if="isCheck"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover16"
            placement="right"
            title="资格证类型："
            width="200"
            trigger="click"
            :content="staffDetail.staffBasis.securityStaffType"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':isCheck}">
          <span v-if="isCheck">*</span>
          <h4 class="flex_shrink">开户银行：</h4>
          <span
            :class="{'ellipsis':$store.getters.tagView}"
            :title="staffDetail.staffBasis.bank"
          >{{ staffDetail.staffBasis.bank?staffDetail.staffBasis.bank:"暂无" }}</span>
          <i class="el-icon-view view_history" v-popover:popover17 v-if="isCheck"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover17"
            placement="right"
            title="开户银行："
            width="200"
            trigger="click"
            :content="staffDetail.staffBasis.bank"
          ></el-popover>
        </el-col>
        <el-col :span="6" class="media_col padding-tb10 flex_class" :class="{'contrast':isCheck}">
          <span v-if="isCheck">*</span>
          <h4 class="flex_shrink">银行卡号：</h4>
          <span
            :class="{'ellipsis':$store.getters.tagView}"
            :title="staffDetail.staffBasis.cardNum"
          >{{ staffDetail.staffBasis.cardNum ?staffDetail.staffBasis.cardNum:"暂无" }}</span>
          <i class="el-icon-view view_history" v-popover:popover18 v-if="isCheck"></i>
          <!-- 显示 -->
          <el-popover
            ref="popover18"
            placement="right"
            title="银行卡号："
            width="200"
            trigger="click"
            :content="staffDetail.staffBasis.cardNum"
          ></el-popover>
        </el-col>
          <el-col
          :span="6"
          class="media_col padding-tb10 cell el-tooltip"
          :class="{ contrast: isCheck }"
        >
          <span v-if="isCheck">*</span>
          <h4>合同起始：</h4>
          {{ staffDetail.staffStation.contractBeginTime }}
          <i
            class="el-icon-view view_history"
            v-popover:popover1
            v-if="isCheck"
          ></i>
          <el-popover
            ref="popover1"
            placement="right"
            title="合同起始："
            width="200"
            trigger="click"
            :content="staffDetail.staffStation.contractBeginTime"
          ></el-popover>
        </el-col>
        <el-col
          :span="6"
          class="media_col padding-tb10"
          :class="{ contrast: isCheck }"
        >
          <span v-if="isCheck">*</span>
          <h4>合同截止：</h4>
          <span
            :class="isExpire == 2 ? 'red' : isExpire == 1 ? 'wraning' : ''"
            >{{ staffDetail.staffStation.contractEndTime }}</span
          >
          <i
            class="el-icon-view view_history"
            v-popover:popover2
            v-if="isCheck"
          ></i>
          <el-popover
            ref="popover2"
            placement="right"
            title="合同截止："
            width="200"
            trigger="click"
            :content="staffDetail.staffStation.contractEndTime"
          ></el-popover>
        </el-col>
        <!-- 离职时间以及离职原因 -->
        <el-col
          :span="6"
          class="media_col padding-tb10 flex_class"
          v-if="staffDetail.staffBasis.quitStatus == 1"
        >
          <h4 class="flex_shrink">离职时间：</h4>
          <span
            :class="{'ellipsis':$store.getters.tagView}"
            :title="staffDetail.staffBasis.quitTime"
          >{{ staffDetail.staffBasis.quitTime }}</span>
        </el-col>

        <el-col
          :span="6"
          class="media_col padding-tb10 flex_class"
          v-if="staffDetail.staffBasis.quitStatus == 1"
        >
          <h4 class="flex_shrink">离职原因：</h4>
          <span
            :class="{'ellipsis':$store.getters.tagView}"
            :title="staffDetail.staffBasis.reasons"
          >{{ staffDetail.staffBasis.reasons }}</span>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'CardInfo',
  props: {
    staffDetail: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    isExpire () {
      let flag = 3 // moren
      let newdDate = new Date().getTime()
      let oldDate = new Date(
        this.staffDetail.staffStation.contractEndTime
      ).getTime()
      //  差值 转换成天数
      let val = Math.floor((oldDate - newdDate) / 1000 / 60 / 60 / 24)
      if (val <= 45 && val > 30) {
        flag = '1'
      } else if (val <= 30) {
        flag = '2'
      } else {
        flag = '3'
      }
      return flag
    }
  },
  data () {
    return {
      isCheck: false // 临时
    }
  }
}
</script>

<style lang="scss" scoped>
$color: #409eff;
.contrast {
  color: $color;
}
.view_history {
  cursor: pointer;
  margin-left: 10px;
}
</style>
